// TO-DO: change all places calling process.env directly to use this file
export default {
	env: process.env.NODE_ENV,
	crispWebSiteId: process.env.REACT_APP_CRISP_WEBSITE_ID
}
